import initialState from '../initialstate';
import * as actions from '../../actions/actiontypes';

export default function userPresenceReducer(state = initialState.userPresence, action) {
	switch (action.type) {
		case actions.GET_USER_PRESENCE: {
			let userPresence = false;
			if (action.response) {
				if (action.error) {
					userPresence = {
						error: action.error
					};
				} else {
					userPresence = action.response;
				}
			}

			return {
				...state,
				[action.objectId]: userPresence
			};
		}

		case actions.RESET_USER_PRESENCE: {
			// Set back the userPresence to undefined
			let result = {...state};
			if (result[action.objectId] !== undefined) {
				delete result[action.objectId];
			}

			return result;
		}

		default:
			return state;
	}
}
